/* global modForm modUtils */
export function saveOriginalReferrerCookie() {
	if (document.referrer.indexOf(window.location.host) < 0 && !modUtils.getCookie(modForm.opts.referrerCookieName)) {
		modUtils.setCookie(modForm.opts.referrerCookieName, document.referrer, modForm.opts.referrerCookieExpiration);
	}
}
